import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/LoginView.vue'
import SignupView from '../views/SignupView.vue'

Vue.use(VueRouter)

const routes = [
  // AGREGA ESTO EN EL const routes PARA REDIRECCIONAR LAS RUTAS QUE NO EXISTAN EN UN MÓDULO.
  {
    path: '/signup',
    name: 'signup',
    component: SignupView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '*',
    redirect: '/login'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BACKEND_URL || '/api',
  routes
})

export default router
